import { __rest } from "tslib";
import React from 'react';
import { ComponentSize } from '../types';
import { Stepper } from '../Stepper';
import { PriceInputGroup, StyledTextField, PrefixContainer, PrefixText } from './styled';
import { withLabels } from '../../hoc';
const fractionDigits = 2;
function stringToFixed(price) {
    const floatPrice = parseFloat(price.replace(',', '.'));
    return floatPrice.toFixed(fractionDigits);
}
export const PriceInput = withLabels((_a) => {
    var { className = '', hasError, currency, disabled = false, onChange, onPriceChange, priceValue, step = '0.1', size = ComponentSize.base } = _a, otherProps = __rest(_a, ["className", "hasError", "currency", "disabled", "onChange", "onPriceChange", "priceValue", "step", "size"]);
    const handleChange = (value) => onChange(value.replace(/[a-zA-Z]/g, '').replace(',', '.'));
    const handleBlur = (e) => {
        const target = e.target;
        const { value } = target;
        if (!value) {
            onPriceChange('');
            return;
        }
        const roundedValue = stringToFixed(value);
        onPriceChange(roundedValue);
    };
    const handleIncrement = (callback = onPriceChange) => {
        const currentPrice = parseFloat(priceValue) || 0;
        const currentStep = parseFloat(step);
        callback((currentPrice + currentStep).toFixed(fractionDigits));
    };
    const handleDecrement = (callback = onPriceChange) => {
        const currentPrice = parseFloat(priceValue) || 0;
        const currentStep = parseFloat(step);
        callback((currentPrice - currentStep).toFixed(fractionDigits));
    };
    const handleKeyDown = (e) => {
        const { key } = e;
        const target = e.target;
        const isInForm = target.form;
        if (!isInForm) {
            if (key === 'Enter')
                target.blur();
        }
        if (key === 'ArrowUp')
            handleIncrement(onChange);
        if (key === 'ArrowDown')
            handleDecrement(onChange);
    };
    return (React.createElement(PriceInputGroup, { className: className, hasError: hasError },
        React.createElement(PrefixContainer, { disabled: disabled, size: size },
            React.createElement(PrefixText, { variant: "hintText" }, currency)),
        React.createElement(StyledTextField, Object.assign({ placeholder: "0.00", type: "currency", value: priceValue, step: step, onChange: handleChange, onBlur: handleBlur, onKeyDown: handleKeyDown, disabled: disabled, size: size }, otherProps)),
        React.createElement(Stepper, { onIncrement: () => handleIncrement(), onDecrement: () => handleDecrement(), disabled: disabled, size: size })));
});
PriceInput.displayName = 'PriceInput';
//# sourceMappingURL=PriceInput.js.map